import React, { useState, useEffect } from "react";
import NavLinks from "../Navbar/NavLinks";
import { HashLink } from "react-router-hash-link";
import logo from "../../images/clients/teqnodux_lodo.png";

const NavBar = ({ isDarkMode = false }) => {
  const [top, setTop] = useState(!window.scrollY);
  const [isOpen, setisOpen] = React.useState(false);
  function handleClick() {
    setisOpen(!isOpen);
  }

  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);

  return (
    <nav
      className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16  ${
        !top
          ? isDarkMode
            ? "bg-gray-800 shadow-lg"
            : "bg-white shadow-lg"
          : isDarkMode
          ? "bg-gray-900"
          : ""
      }`}
    >
      <div className="flex flex-row sm:justify-between justify-around items-center py-2">
        <div
          className={`flex flex-row justify-center md:px-12 md:mx-12 items-center text-center font-semibold ${
            isDarkMode ? "brightness-0 invert" : ""
          }`}
        >
          <HashLink smooth to="/#home">
            <img
              src={logo}
              alt="Logo"
              className={`h-14 w-auto sm:transform sd:transition-transform sm:duration-300 sm:ease-in-out sm:hover:scale-110 ${
                isDarkMode ? "brightness-0 invert" : ""
              }`} // Add scaling on hover
            />
          </HashLink>
        </div>
        <div className="group flex flex-col items-center">
          <button
            className={`p-2 rounded-lg lg:hidden ${
              isDarkMode ? "text-gray-200" : "text-blue-900"
            }`}
            onClick={handleClick}
          >
            <svg
              className="h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              {isOpen && (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                />
              )}
              {!isOpen && (
                <path
                  fillRule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                />
              )}
            </svg>
          </button>
          <div className="hidden space-x-6 lg:inline-block p-5">
            <NavLinks isDarkMode={isDarkMode} />
          </div>

          <div
            className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-24 lg:hidden shadow-xl top-[72px] ${
              isDarkMode ? "bg-gray-800" : "bg-white"
            } ${isOpen ? "block" : "hidden"}`}
          >
            <div className="flex flex-col space-y-6">
              <NavLinks isDarkMode={isDarkMode} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
